import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-close-button',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './close-button.component.html',
  styleUrl: './close-button.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CloseButtonComponent {
  @Output() readonly onCloseClicked = new EventEmitter<void>();

  /**
   * Emits the search data event.
   *
   * @returns void
   */
  public onSubmit(): void {
    this.onCloseClicked.emit();
  }
}
